import { RootState } from 'editor/src/store/index';
import shouldDigitizeCurrentSpread from 'editor/src/store/utils/shouldDigitizeCurrentSpread';

import getCustomerUploadedFonts from './getCustomerUploadedFonts';
import getDesignBundledFonts from './getDesignBundledFonts';
import isOnlyUploadedFonts from './isOnlyUploadedFonts';

/**
 * GAPI-61790: the font a newly added text gets. Normally the editor's current text font, which
 * starts as the bundled default. With "Use only uploaded fonts" on, that default may be a font
 * the customer is not offered, so it falls back to the first uploaded font unless the current
 * font is one the picker offers (an uploaded font, or a bundled one the design already uses).
 */
function getNewTextFontFamily(state: RootState) {
  const { fontFamily } = state.editor.currentStyles.text;
  // Same scope as the picker: an embroidery spread hides the uploaded fonts and needs a digitizable font.
  if (!isOnlyUploadedFonts(state) || shouldDigitizeCurrentSpread(state)) {
    return fontFamily;
  }

  const uploadedFonts = getCustomerUploadedFonts(state);
  const offered =
    uploadedFonts.some((font) => font.fontFile === fontFamily) ||
    getDesignBundledFonts(state).some((font) => font.metadata.fontFile === fontFamily);

  return offered ? fontFamily : uploadedFonts[0].fontFile;
}

export default getNewTextFontFamily;
